import { PreferencesDateFieldOrder } from '@shared/core/preferences'

export const locales = [
  { tag: 'in', name: 'Bahasa Indonesia', englishName: 'Indonesian' },
  { tag: 'ca', name: 'Català', englishName: 'Catalan' },
  { tag: 'cs', name: 'Čeština', englishName: 'Czech' },
  { tag: 'da', name: 'Dansk', englishName: 'Danish' },
  { tag: 'de', name: 'Deutsch', englishName: 'German' },
  { tag: 'en_GB', name: 'English (UK)', englishName: 'English (UK)' },
  { tag: 'en', name: 'English (US)', englishName: 'English (US)' },
  { tag: 'es', name: 'Español', englishName: 'Spanish' },
  { tag: 'es_419', name: 'Español (Latinoamérica)', englishName: 'Spanish (Latin America)' },
  { tag: 'tl', name: 'Filipino', englishName: 'Filipino' },
  { tag: 'fr', name: 'Français', englishName: 'French' },
  { tag: 'hr', name: 'Hrvatski', englishName: 'Croatian' },
  { tag: 'it', name: 'Italiano', englishName: 'Italian' },
  { tag: 'lv', name: 'Latviešu', englishName: 'Latvian' },
  { tag: 'lt', name: 'Lietuvių', englishName: 'Lithuanian' },
  { tag: 'hu', name: 'Magyar', englishName: 'Hungarian' },
  { tag: 'nl', name: 'Nederlands', englishName: 'Dutch' },
  { tag: 'no', name: 'Norsk', englishName: 'Norwegian' },
  { tag: 'pl', name: 'Polski', englishName: 'Polish' },
  { tag: 'pt_BR', name: 'Português (Brasil)', englishName: 'Portuguese (Brazil)' },
  { tag: 'pt_PT', name: 'Português (Portugal)', englishName: 'Portuguese (Portugal)' },
  { tag: 'ro', name: 'Română', englishName: 'Romanian' },
  { tag: 'sk', name: 'Slovenčina', englishName: 'Slovak' },
  { tag: 'sl', name: 'Slovenščina', englishName: 'Slovenian' },
  { tag: 'fi', name: 'Suomi', englishName: 'Finnish' },
  { tag: 'sv', name: 'Svenska', englishName: 'Swedish' },
  { tag: 'tr', name: 'Türkçe', englishName: 'Turkish' },
  { tag: 'vi', name: 'Tiếng Việt', englishName: 'Vietnamese' },
  { tag: 'el', name: 'Ελληνικά', englishName: 'Greek' },
  { tag: 'ru', name: 'Русский', englishName: 'Russian' },
  { tag: 'sr', name: 'Српски', englishName: 'Serbian' },
  { tag: 'uk', name: 'Українська', englishName: 'Ukrainian' },
  { tag: 'bg', name: 'Български', englishName: 'Bulgarian' },
  { tag: 'iw', name: 'עברית', englishName: 'Hebrew' },
  { tag: 'ar', name: 'العربية', englishName: 'Arabic' },
  { tag: 'fa', name: 'فارسی', englishName: 'Persian' },
  { tag: 'hi', name: 'हिन्दी', englishName: 'Hindi' },
  { tag: 'th', name: 'ไทย', englishName: 'Thai' },
  { tag: 'zh_TW', name: '中文 (繁體)', englishName: 'Chinese (Traditional)' },
  { tag: 'zh_CN', name: '中文 (简体)', englishName: 'Chinese (Simplified)' },
  { tag: 'ja', name: '日本語', englishName: 'Japanese' },
  { tag: 'ko', name: '한국어', englishName: 'Korean' },
]

export function formatDateInLocale(
  date: Date,
  locale: string,
  dateFieldOrder: PreferencesDateFieldOrder,
  timezone?: string,
) {
  locale = (locale || 'en').replace('_', '-')

  // ISO 8601 format is always YYYY-MM-DD regardless of locale
  if (dateFieldOrder === 'YMD') {
    return date.toISOString().split('T')[0]
  }

  // Get locale-specific formatting to determine separators and conventions
  const formatter = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: timezone || 'UTC',
  })

  // Extract the parts from the formatted string
  const parts = formatter.formatToParts(date)
  const yearPart = parts.find((part) => part.type === 'year')?.value || ''
  const monthPart = parts.find((part) => part.type === 'month')?.value || ''
  const dayPart = parts.find((part) => part.type === 'day')?.value || ''

  // Find the separator used in this locale
  const separator = parts.find((part) => part.type === 'literal')?.value || '/'

  // Reconstruct the date based on the requested field order
  if (dateFieldOrder === 'DMY') {
    return `${dayPart}${separator}${monthPart}${separator}${yearPart}`
  }

  // Default to mdy
  return `${monthPart}${separator}${dayPart}${separator}${yearPart}`
}
